import React, { Component } from 'react';
import axios from "axios";
import CompareCatRow from './compare-catrow';

export default class CompareCat extends Component {
	constructor(props) {
	    super(props);
	    this.state = {
	      	categories: [],
			date: [],
			reports: [],
			reportsBySourceCat: [],
			countlist: 0,
			countFBList: 0,
			updatedData: false
	    }
	}
	UNSAFE_componentWillReceiveProps(nextProps) {
		const { categories, date, reportsBySourceCat, hasReportDataCatsSource } = nextProps;
		
		this.setState({
	        categories,
	        date,
	        reportsBySourceCat
	      });
				
		if (categories && hasReportDataCatsSource 
			&& hasReportDataCatsSource[hasReportDataCatsSource.length - 1] 
			&& categories[categories.length - 1].value === hasReportDataCatsSource[hasReportDataCatsSource.length - 1].value && !this.state.updatedData
		) {
			this.setState({updatedData: true});
			this.props.revalidateStaleCatsSource();
		}
	}

	handleUpdatedDataAnalyticsRow = (data) => {
		if (this.props.showSnackBar) {
			const cate = this.props.categories.find(c => c.value === data.value);
			this.props.showSnackBar({ mess: `Thống kê nguồn ${cate.label} vừa mới cập nhật!`, type: "success" });
		}
	}
	
	render() {
		const { categories, date, reports, reportsBySourceCat } = this.state;
		
		if(reportsBySourceCat.length == 0){
			return (
        		<div className="spinner-border" role="status">
				  <span className="sr-only">Loading...</span>
				</div>
        	);
		}
		else{
			return (
		    	<div className="table-responsive">
	                <table className="m-0 table table-striped table-valign-middle">
	                  <thead>
	                    <tr>
	                      <th className="w--10">Chuyên mục</th>
	                      <th className="w--8">Cùng kì</th>
	                      <th className="w--8">Hiện tại</th>
	                      <th className="w--8">Tăng trưởng</th>
	                    </tr>
	                  </thead>
	                  <tbody>
	                    {reportsBySourceCat && reportsBySourceCat.map((data,idx) => (
	                    	data.value != "" ?
	                    		<CompareCatRow
									key={`analytics-source-${idx}`}
									data={data}
									dataSum={reportsBySourceCat.find(({ value }) => value == "")}
									categories={categories}
									handleUpdatedData={this.handleUpdatedDataAnalyticsRow}
								/>
							: null
						))}
						{reportsBySourceCat && reportsBySourceCat.map((data,idx) => (
	                    	data.value == "" ?
	                    		<CompareCatRow
									key={`analytics-source-${idx}`}
									data={data}
									categories={categories}
									handleUpdatedData={this.handleUpdatedDataAnalyticsRow}
								/>
							: null
						))}
	                  </tbody>

	                </table>
	            </div>
		    );
		}
	    
	}

}